export enum NotificationType {
    MAINTENANCE = "MAINTENANCE",
    NEW_FEATURE = "NEW_FEATURE",
    GENERAL = "GENERAL",
    USAGE_LIMIT = "USAGE_LIMIT"
}